/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateContactDto
 */
export interface CreateUpdateContactDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContactDto
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContactDto
     */
    contactTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContactDto
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateContactDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateContactDto interface.
 */
export function instanceOfCreateUpdateContactDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "contactTypeId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateContactDtoFromJSON(json: any): CreateUpdateContactDto {
    return CreateUpdateContactDtoFromJSONTyped(json, false);
}

export function CreateUpdateContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateContactDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'contactTypeId': json['contactTypeId'],
        'email': json['email'],
        'active': json['active'],
    };
}

export function CreateUpdateContactDtoToJSON(value?: CreateUpdateContactDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientId': value.clientId,
        'contactTypeId': value.contactTypeId,
        'email': value.email,
        'active': value.active,
    };
}

